import {
  Target,
  Shield,
  Eye,
  Microscope,
  Clock,
  Wind,
  Leaf,
  Bug,
  Zap,
} from "lucide-react";

export const DISINFESTAZIONE_PAGE = {
  HEADER: {
    TITLE: "Disinfestazione Professionale",
    SUBTITLE: "Eliminazione Definitiva di Insetti e Parassiti",
    DESCRIPTION:
      "Servizio di disinfestazione con tecniche avanzate, prodotti certificati e garanzia di risultato per eliminare ogni tipo di infestante.",
    BACK_BUTTON: "Torna alla Home",
  },

  OVERVIEW: {
    TITLE: "Disinfestazione Efficace e Sicura",
    DESCRIPTION:
      "La presenza di infestanti rappresenta un grave rischio per la salute, l'igiene e la sicurezza degli ambienti. I nostri interventi di disinfestazione utilizzano tecniche scientificamente provate e prodotti certificati per garantire l'eliminazione completa di ogni tipo di parassita.",
    FEATURES: [
      {
        title: "Identificazione Precisa",
        description:
          "Analisi entomologica per identificare la specie e scegliere il trattamento più efficace",
      },
      {
        title: "Prodotti Certificati",
        description:
          "Solo prodotti professionali approvati dal Ministero della Salute",
      },
      {
        title: "Garanzia di Risultato",
        description:
          "Interventi garantiti con possibilità reintervento gratuito se necessario",
      },
    ],
    BUTTONS: {
      PRIMARY: "Preventivo Gratuito",
      SECONDARY: "Chiama: 123 456 7890",
    },
    FORM: {
      TITLE: "Richiedi Preventivo Disinfestazione",
      SUBTITLE:
        "Sopralluogo gratuito e preventivo personalizzato entro 24 ore",
    },
    EMERGENCY: {
      TITLE: "Attenzione!",
      DESCRIPTION:
        "Hai notato insetti in casa o in ufficio? Non sottovalutare il problema! Gli insetti si moltiplicano rapidamente e possono causare gravi danni.",
      BUTTON: "Richiedi Intervento Urgente",
      FORM_TITLE: "Richiedi Intervento Urgente Disinfestazione",
      FORM_SUBTITLE:
        "Intervento rapido per situazioni di emergenza - Risposta entro 2 ore",
    },
  },

  MAIN_IMAGE: {
    URL: "https://images.unsplash.com/photo-1628258334105-2a0b3d6efee1?w=600&h=400&fit=crop",
    ALT: "Tecnico specializzato in disinfestazione",
  },

  PEST_TYPES: {
    TITLE: "Tipi di Infestanti",
    SUBTITLE:
      "La nostra esperienza ci permette di identificare con precisione il tipo di infestante e applicare il trattamento più efficace.",
    CATEGORIES: [
      {
        category: "Insetti Striscianti",
        tabValue: "striscianti",
        icon: Bug,
        pests: [
          {
            name: "Blatte e Scarafaggi",
            description:
              "Insetti notturni che si nascondono in ambienti caldi e umidi, contaminano cibo e superfici",
            characteristics: [
              "Attive di notte",
              "Resistenti",
              "Proliferazione rapida",
              "Vettori di malattie",
            ],
            habitat:
              "Cucine, bagni, cantine, fogne, magazzini alimentari",
            risks:
              "Allergie, asma, contaminazione batterica, cattivi odori",
            image:
              new URL("../../../assets/0455a60d07332b0570e3c689789b9464f4f3f0a6.png", import.meta.url).toString(),
          },
          {
            name: "Formiche",

            description:
              "Insetti sociali che formano colonie, attratte da cibo e sostanze zuccherine",
            characteristics: [
              "Vita sociale organizzata",
              "Proliferazione rapida",
              "Colonie numerose",
              "Adattabilità",
            ],
            habitat:
              "Giardini, rimesse, terrazzi, sottovasi, acque stagnanti, zone ombreggiate",
            risks:
              "Contaminazione alimentare, danni strutturali, invasione massiva",
            image:
              new URL("../../../assets/d8f68ffec7bf24338e7a429c86ac22aaa5f0e3aa.png", import.meta.url).toString(),
          },
          {
            name: "Cimici dei Letti",

            description:
              "Parassiti ematofagi che si nutrono di sangue umano durante il sonno",
            characteristics: [
              "Attive di notte",
              "Resistenti al digiuno",
              "Piccole dimensioni",
              "Diffusione rapida",
            ],
            habitat:
              "Materassi, divani, mobili imbottiti, crepe nei muri",
            risks:
              "Morsi dolorosi, allergie, disturbi del sonno, stress psicologico",
            image:
              new URL("../../../assets/4f0d4dd16a107b368773649b3bd4ddd057c09121.png", import.meta.url).toString(),
          },
          {
            name: "Pulci",
         
            description:
              "Piccoli parassiti ematofagi che infestano animali domestici e possono attaccare anche l'uomo",
            characteristics: [
              "Salti fino a 30 cm",
              "Ciclo vitale complesso",
              "Resistenti al digiuno",
              "Rapida riproduzione",
            ],
            habitat:
              "Pelo di animali, tappeti, moquette, tessuti, crepe del pavimento",
            risks:
              "Morsi pruriginosi, allergie, trasmissione malattie, dermatiti",
            image:
              new URL("../../../assets/6bb1bb00a705f12120b79073daa82e509867e7d0.png", import.meta.url).toString(),
          },
        ],
      },
      {
        category: "Insetti Volanti",
        tabValue: "volanti",
        icon: Wind,
        pests: [
          {
            name: "Zanzare",
            description:
              "Insetti volanti che si riproducono in ambienti acquatici stagnanti",
            characteristics: [
              "Riproduzione in acqua",
              "Attive al tramonto",
              "Volo silenzioso",
              "Attrazione CO2",
            ],
            habitat:
              "Giardini, terrazzi, sottovasi, acque stagnanti",
            risks:
              "Punture dolorose, reazioni allergiche, trasmissione malattie",
            image:
              new URL("../../../assets/705e39388d369fde3b9d1aca33be50e1e301a870.png", import.meta.url).toString(),
          },
          {
            name: "Vespe e Calabroni",
            description:
              "Imenotteri sociali aggressivi che costruiscono nidi in primavera",
            characteristics: [
              "Comportamento aggressivo",
              "Nidi organizzati",
              "Pungiglioni velenosi",
              "Attività diurna",
            ],
            habitat:
              "Sottotetti, cassonetti, alberi, fessure nei muri",
            risks:
              "Punture dolorose, shock anafilattico, aggressività di gruppo",
            image:
              new URL("../../../assets/ee00ad110e561e8594dbc8c12a8e7583ff29e407.png", import.meta.url).toString(),
          },
          {
            name: "Mosche",
            description:
              "Insetti volanti che si nutrono di sostanze organiche in decomposizione",
            characteristics: [
              "Riproduzione veloce",
              "Attrazione rifiuti",
              "Volo erratico",
              "Contaminazione",
            ],
            habitat:
              "Rifiuti, cucine, bagni, aree di decomposizione",
            risks:
              "Trasmissione batteri, contaminazione cibo, disturbo continuo",
            image:
              new URL("../../../assets/8dc91b030d3430e2f51d9035a3e219034157878d.png", import.meta.url).toString(),
          },
        ],
      },
      {
        category: "Aracnidi",
        tabValue: "aracnidi",
        icon: Target,
        pests: [
          {
            name: "Zecche",
        
            description:
              "Aracnidi parassiti che si attaccano alla pelle per nutrirsi di sangue, vettori di malattie gravi",
            characteristics: [
              "Attacco prolungato",
              "Deteczione difficile",
              "Vettori patogeni",
              "Resistenza ambientale",
            ],
            habitat:
              "Erba alta, cespugli, boschi, giardini, pelo di animali",
            risks:
              "Malattia di Lyme, encefalite, febbre bottonosa, infezioni batteriche",
            image:
              new URL("../../../assets/c317138f7ee2d9abc5aa2701dbd8b8c64fe22f3b.png", import.meta.url).toString(),
          },
          {
            name: "Ragni",
            
            description:
              "Aracnidi predatori che costruiscono ragnatele, alcune specie possono essere velenose",
            characteristics: [
              "Costruzione ragnatele",
              "Predatori naturali",
              "Veleno neurotossico",
              "Attività notturna",
            ],
            habitat:
              "Angoli, soffitti, cantine, garage, fessure nei muri, legnaie",
            risks:
              "Fobie, morsi dolorosi, veleno neurotossico, shock anafilattico",
            image:
              new URL("../../../assets/99f987443c42e3e78822155c0520e975fc3f4b9a.png", import.meta.url).toString(),
          },
          {
            name: "Scorpioni",
            
            description:
              "Aracnidi con pungiglione velenoso, attivi di notte e potenzialmente pericolosi",
            characteristics: [
              "Pungiglione velenoso",
              "Attività notturna",
              "Resistenza estrema",
              "Cacciatori solitari",
            ],
            habitat:
              "Pietre, muri a secco, cantine, sottotetti, legnaie, luoghi bui",
            risks:
              "Punture velenose, dolore intenso, reazioni allergiche, shock",
            image:
              new URL("../../../assets/a703fc17e27ce7bc56d8bbd7ad72bfeb226fcbc9.png", import.meta.url).toString(),
          },
          {
            name: "Acari",
           
            description:
              "Aracnidi microscopici che causano allergie respiratorie e infestazioni cutanee",
            characteristics: [
              "Dimensioni microscopiche",
              "Allergenici potenti",
              "Ambienti umidi",
              "Riproduzione veloce",
            ],
            habitat:
              "Materassi, cuscini, tappeti, pelle umana, tessuti, polvere domestica",
            risks:
              "Allergie respiratorie, asma, scabbia, dermatiti, disturbi del sonno",
            image:
              new URL("../../../assets/a47f67fde96a32e8ece371aab49652e0911b451a.png", import.meta.url).toString(),
          },
        ],
      },
      {
        category: "Infestanti del Legno",
        tabValue: "legno",
        icon: Leaf,
        pests: [
          {
            name: "Tarli del Legno",

            description:
              "Coleotteri che scavano gallerie nel legno causando danni strutturali",
            characteristics: [
              "Larve xilofaghe",
              "Danni strutturali",
              "Ciclo lungo",
              "Difficile individuazione",
            ],
            habitat: "Mobili in legno, travi, parquet, cornici",
            risks:
              "Danni strutturali gravi, indebolimento legno, perdita valore",
            image:
              new URL("../../../assets/d4fb461f6f3cc25b9c8806f09461ee807d4c4e4e.png", import.meta.url).toString(),
          },
          {
            name: "Termiti",
            description:
              "Insetti sociali che si nutrono di cellulosa causando gravi danni strutturali",
            characteristics: [
              "Vita sotterranea",
              "Colonie organizzate",
              "Danni ingenti",
              "Difficile rilevamento",
            ],
            habitat:
              "Legno interrato, fondazioni, strutture lignee",
            risks:
              "Crolli strutturali, danni economici enormi, instabilità edifici",
            image:
              new URL("../../../assets/a9f13eed17d46375edf33f8866680133f8669b2e.png", import.meta.url).toString(),
          },
        ],
      },
    ],
  },

  TECHNIQUES: {
    TITLE: "Le Nostre Tecniche",
    SUBTITLE:
      "Utilizziamo diverse metodologie professionali, selezionando la tecnica più appropriata in base al tipo di infestante e alle caratteristiche dell'ambiente.",
    METHODS: [
      {
        id: "gel-baits",
        title: "Gel, Esche Alimentari e Feromoni",
        description:
          "Sistemi di controllo mirati che attirano gli insetti verso esche contaminate per un controllo efficace dell'intera colonia",
        icon: Target,
        features: [
          "Attrattivi specifici per specie",
          "Effetto a catena sulla colonia",
          "Sicuri per bambini e animali",
          "Lunga durata d'azione",
        ],
        applications: [
          "Blatte e scarafaggi",
          "Formiche",
          "Insetti striscianti",
          "Insetti dellle derrate",
        ],
      },
      {
        id: "spray-treatment",
        title: "Trattamenti Irrorati e Nebulizzati",
        description:
          "Applicazione di prodotti fitosanitari professionali tramite nebulizzazione e irrorazione per raggiungere anche le zone più nascoste",
        icon: Wind,
        features: [
          "Copertura totale degli ambienti",
          "Principi attivi certificati",
          "Effetto abbattente immediato",
          "Residualità prolungata",
        ],
        applications: [
          "Insetti volanti",
          "Insetti striscianti",
          "Sanificazione completa",
        ],
      },
      {
        id: "fumigation",
        title: "Fumigazione Professionale",
        description:
          "Trattamento con fumi caldi o freddi con azione abbattente per la disinfestazione totale di ambienti chiusi",
        icon: Zap,
        features: [
          "Penetrazione totale",
          "Aree delimitate",
          "Controllo termiti e tarli",
          "Certificazione fitosanitaria",
        ],
        applications: [
          "Magazzini",
          "Container",
          "Infestazioni massive",
        ],
      },
      {
        id: "monitoring",
        title: "Sistemi di Monitoraggio",
        description:
          "Installazione di stazioni di controllo e trappole per il monitoraggio continuo e la prevenzione",
        icon: Eye,
        features: [
          "Controllo costante",
          "Identificazione precoce",
          "Mappatura infestazioni",
          "Report periodici",
        ],
        applications: [
          "Prevenzione",
          "Controllo qualità",
          "Piani HACCP",
        ],
      },
    ],
  },

  PROCESS: {
    TITLE: "Il Nostro Processo in 5 Fasi",
    SUBTITLE:
      "Un approccio sistematico per garantire l'eliminazione completa degli infestanti",
    PHASES: [
      {
        step: "1",
        title: "Ispezione",
        description:
          "Sopralluogo dettagliato per identificare specie, grado di infestazione e cause",
        icon: Target,
        color: "bg-blue-100 text-blue-600",
      },
      {
        step: "2",
        title: "Analisi",
        description:
          "Valutazione dei rischi e scelta della strategia di intervento più appropriata",
        icon: Microscope,
        color: "bg-green-100 text-green-600",
      },
      {
        step: "3",
        title: "Trattamento",
        description:
          "Applicazione dei prodotti e tecniche selezionate con massima precisione",
        icon: Shield,
        color: "bg-purple-100 text-purple-600",
      },
      {
        step: "4",
        title: "Verifica",
        description:
          "Controllo dell'efficacia del trattamento e valutazione dei risultati",
        icon: Eye,
        color: "bg-orange-100 text-orange-600",
      },
      {
        step: "5",
        title: "Prevenzione",
        description:
          "Consigli e misure preventive per evitare future infestazioni",
        icon: Clock,
        color: "bg-red-100 text-red-600",
      },
    ],
  },

  CTA_SECTION: {
    TITLE: "Pronto per Eliminare gli Infestanti?",
    DESCRIPTION:
      "Non aspettare che il problema peggiori. Contattaci oggi per un preventivo gratuito e scopri la soluzione più efficace per la tua situazione.",
    PRIMARY_BUTTON: "Preventivo Gratuito",
    FORM_TITLE: "Richiedi Preventivo Disinfestazione",
    FORM_SUBTITLE:
      "Sopralluogo gratuito e preventivo personalizzato entro 24 ore",
    DEFAULT_SERVICE: "disinfestazione",
  },
} as const;